import useIntersectionObserver from "../hooks/useIntersectionObserver";
// import Counter from "../components/Counter";
import HowItWorks from "../components/HowItWorks";
import CallToAction from "../components/CallToAction";
import { Link } from "react-router-dom";

function AboutUs() {
	const sectionsRef = useIntersectionObserver(
		(target) => {
			target.classList.add("visible");
		},
		{ threshold: 0.1 }
	);

	const scrollToTop = () => {
		window.scrollTo(0, 0);
	};

	return (
		<section className="aboutUsSection">
			<div
				ref={(el) => (sectionsRef.current[0] = el)}
				className=" desktopMaxWidth sectionHeroContainer"
			>
				<p className="sectionHeroTitle">About Us</p>
				<p className="sectionHeroText">Home / About Us</p>
			</div>

			<div
				ref={(el) => (sectionsRef.current[1] = el)}
				className=" aboutCard desktopMaxWidth"
			>
				<div className="aboutCardLeftPane">
					<p className="tag aboutCardTag">Mindset</p>
					<p className="aboutCardTagline">
						Your mental health is our top priority.
					</p>
				</div>
				<div className="aboutCardRightPane">
					<p className="intro">
						At Trusted Counseling and Consulting, we believe in providing a
						welcoming space for all.
					</p>
					<p className="rightPaneText">
						We're committed to helping you achieve optimal health and wellness.
						With a focus on well-being, we combine expert knowledge with
						innovative approaches.
					</p>
					<Link
						to="/contact"
						className="cta ctaSecondary ctaThird"
						onClick={scrollToTop}
					>
						Contact Us
					</Link>
				</div>
			</div>

			{/* <Counter /> */}

			<div
				className="personalizedSolutionsContainer desktopMaxWidth"
				ref={(el) => (sectionsRef.current[2] = el)}
			>
				<p className="personalizedSolutionsTitle">
					Personalized <span>Solutions</span> for our valuable Clients
				</p>
				<div className="aboutFeaturesExtra">
					<div className="extraFeature">
						<i className="fa-solid fa-credit-card"></i>
						<div className="extraFeatureContainer">
							<p className="extraFeatureTitle">Easy Billing System</p>
							<p className="extraFeatureText">
								A seamless billing experience that prioritizes your convenience
								and peace of mind.
							</p>
						</div>
					</div>
					<div className="extraFeature">
						<i className="fa-solid fa-user-tie"></i>
						<div className="extraFeatureContainer">
							<p className="extraFeatureTitle">Personalized Therapy Sessions</p>
							<p className="extraFeatureText">
								Personalized therapy sesssions with an Expert for an improved
								mental health.
							</p>
						</div>
					</div>
				</div>
			</div>
			<HowItWorks />
			<CallToAction />
		</section>
	);
}

export default AboutUs;
